exports.caseLogicMsg = function (message, nodeId, metadata = {}) {
  return {
    message,
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      ...metadata,
      scope: 'control',
    },
  };
}

exports.medicationMsg = function(message, medicationId, metadata = {}) {
  return {
    message,
    category: 'medications',
    field: 'medications',
    id: medicationId,
    metadata: {
      ...metadata,
      scope: 'control',
    },
  };
}

exports.fluidMsg = function(message, fluidId, metadata = {}) {
  return {
    message,
    category: 'medications',
    field: 'fluids',
    id: fluidId,
    metadata: {
      ...metadata,
      scope: 'control',
    },
  };
}

exports.dosageMsg = function(message, dosageFormId, metadata = {}) {
  return {
    message,
    category: 'medications',
    field: 'dosageForms',
    id: dosageFormId,
    metadata: {
      ...metadata,
      scope: 'control',
    },
  };
}

exports.conditionsMsg = function(message, id, metadata = {}) {
  return {
    message,
    category: 'patientConditions',
    field: '_intialStates',
    id,
    metadata: {
      ...metadata,
      scope: 'control'
    }
  };
}

exports.proceduresMsg = function(message, id, metadata = {}) {
  return {
    message,
    category: 'procedures',
    field: '_treatments',
    id,
    metadata: {
      ...metadata,
      scope: 'control'
    }
  };
}